import { MedicalConfigSection } from "@/apidtos";
import { useRootLoaderData } from "@/root"

export const useMedicalConfig = () => {
  const { config } = useRootLoaderData();
  return config.Medical as MedicalConfigSection;
};
